<template>
  <f7-page>
    <div class="main-content h-100" :class="isFirstLoginTrue ? 'filter-blur-20px' : ''">
      <b-container :class="{'w-60' : getCols < 5}" class="d-flex align-items-center justify-content-center main-page-positionning">
        <b-row align-h="start" :cols="getCols">
          <b-col v-for="(action, index) in data" :key="action.id">
            <b-container class="homeButton" :class="getColor(index)" @click="redirect(action.link)" fluid>
              <b-row class="blocHome">
                <b-col cols="9"><i :class="action.icon" class="homeButtonIcon fa"></i></b-col>
              </b-row>
              <b-row class="d-flex-end h-50">
                <b-col cols="9"><div class="w-100 fs-19px font-weight-bold text-white">{{ $t(action.title) }}</div></b-col>
              </b-row>
            </b-container>
          </b-col>
        </b-row>
      </b-container>
      <footer class="pb-10px">
        <b-row>
          <b-col class="xs-12 text-center">
            <b-col class="d-flex justify-content-center align-items-center">
              <img class="logoStreammind" alt="Streammind" :src="logoStreammind"></img>
              <span>{{ $t('common.copyright')}}</span>&nbsp;
              <span>{{ version }}</span>
            </b-col>
          </b-col>
        </b-row>
      </footer>
    </div>
  </f7-page>
</template>

<script>
import buttonsData from '@/pages/user/data/homepageData.json'
import _ from 'lodash'
import Img from '../../assets/static/images/homepage/accueil.jpg'
import Logo from './../../assets/static/images/StreamMind_horizontal.png'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import DealPrudenceLogo from '../../assets/static/images/homepage/dealprudence_texte_seul.png'
import StreammindImage from './../../assets/static/images/streammind-text-seul.png'

/* import font awesome icon component */
/* import specific icons */

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Homepage',
  components: {
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  computed: {
    isFirstLoginTrue () {
      if (this.$engine.user.getIsFirstLogin() === '1' || this.$engine.user.get().isFirstLogin === '1') {
        return true
      } else {
        return false
      }
    },
    getCols () {
      if (this.data.length < 5) {
        if (this.data.length < 2) {
          return '1'
        } else {
          return '2'
        }
      }
      return '3'
    }
  },
  data () {
    return {
      data: [],
      imgLogo: Logo,
      logoStreammind: StreammindImage,
      MrBgLogo: DealPrudenceLogo,
      nbButtons: 0,
      nbMaxItem: 3,
      nbMaxColor: 4,
      color: ['#4CD8C4','#F59655','#FA7C57','#EE89A6'],
      colors: ['0'],
      version: ''
    }
  },
  created () {
    console.log(this.$f7.mainView)
    this.$bus.emit('isOnHomepage', true)
    this.$$('.homepageNavbar').removeClass('deleteNavBar')
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: '',
      navTitle: '',
      returnUrl: ''
    })
    let availableButtons = []
    let that = this
    buttonsData.buttons.forEach(item => {
      if (!item.disabled && item.norm_right_SRTP && item.norm_right_HRTP && this.$engine.user.getUserNorm()) {
        if (this.$engine.user.getUserNorm() === '1' && this.hasRight(item.norm_right_SRTP)) {
          that.getCardClass
          item.class = that.getCardClass(item) + ' ' + item.class
          availableButtons.push(item)
        } else if (this.$engine.user.getUserNorm() === '2' && this.hasRight(item.norm_right_HRTP)) {
          that.getCardClass
          item.class = that.getCardClass(item) + ' ' + item.class
          availableButtons.push(item)
        }
      } else if (!item.disabled && this.hasRight(item.right)) {
        that.getCardClass
        item.class = that.getCardClass(item) + ' ' + item.class
        availableButtons.push(item)
      }
    })
    let dataCopy = availableButtons.filter(elem => that.hasRight(elem.right))
    let settingsFound = false
    let settingsRtpFound = false
    dataCopy.forEach((item => {
      if (item.id === 3) {
        settingsFound = true
      }

      if (item.id === 4) {
        settingsRtpFound = true
      }
    }))

    this.data = dataCopy
    if (this.data.length < this.nbMaxItem) {
      this.nbMaxItem = this.data.length
    }
    if (this.$engine.versionAPI) {
      this.version = 'Version ' + this.$engine.versionAPI
    } else {
      this.$engine.getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.$engine.versionAPI = resp.data.version
          if (that.$engine.versionAPI) {
            that.version = 'Version ' + that.$engine.versionAPI
          }
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })
    }
  },
  mounted () {
    this.tryRedirect()
  },
  methods: {
    tryRedirect () {
      let previousPage = this.$f7.getCurrentView().history[this.$f7.getCurrentView().history.length - 1]
      if (previousPage === '/login/') {
        this.$bus.emit('refresh-cache-menu')
      }
    },
    getColor(index) {
      // Récupérer la couleur en fonction de l'index
      return 'card-color-' + (index % this.color.length)
    },
    getCardClass (button) {
      this.nbButtons++
      return ('homeCardBody-' + ((this.nbButtons % this.nbMaxColor) + 1))
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, true)
    },
    redirect (url) {
      this.$bus.$emit('switch-selected-menu', url)
      loadPage(this, { url: url })
    }
  }
}
</script>
<style scoped>

.main-content {
  background-color: #1CB3B2;
}

@media (max-width:991px) {
  .main-content {
    height: calc(100% - 44px);
  }
}

</style>
